import React from 'react';
import PropTypes from 'prop-types';

import { parseHtml } from 'helpers/index';
import { QUESTION_TYPE } from 'constants/constants';

import MTPchoiceResult from './MTPchoiceResult';
import RatingResult from './RatingResult';
import ScalingResult from './scalingResult';
import styled from '@emotion/styled';

const ResultItem = ({ result, isEnd, index }) => {
  const renderAnswer = () => {
    if (result?.type === QUESTION_TYPE.FREETEXT) {
      return (
        <>
          <div className="whiteSpacePre">{result?.result}</div>
        </>
      );
    }

    if (result?.type === QUESTION_TYPE.MTC) {
      return <MTPchoiceResult result={result} />;
    }
    if (result?.type === QUESTION_TYPE.RATING) {
      return <RatingResult result={result} />;
    }
    if (result?.type === QUESTION_TYPE.SCALING)
      return <ScalingResult result={result?.resultAnswers} />;
  };

  const P_TAG = styled.p`
    font-weight: 600;
    border-radius: 2px;
    background-color: #d8dbde;
    color: #4a4a4a;
    position: relative;
    &::after {
      content: '';
      position: absolute;
      width: 7px;
      height: 7px;
      border-radius: 50%;
      top: 50%;
      left: 7px;
      background-color: #cb6363;
      transform: translateY(-50%);
    }
  `;

  return (
    <div>
      {result?.content && (
        <div className="my-05">
          <strong>Question:</strong>
          <div className="d-flex">
            <span className="mr-05">{`${index + 1})`}</span>
            {parseHtml(result?.content, 'overflow-x-auto')}
          </div>
        </div>
      )}
      <div>
        <strong>Your answer:</strong>
        {(Array.isArray(result?.resultAnswers) &&
          result?.type === QUESTION_TYPE.MTC &&
          !!result?.resultAnswers?.find((val) => val)) ||
        (result?.resultAnswers?.length &&
          result?.type !== QUESTION_TYPE.MTC &&
          typeof result?.resultAnswers === 'object' &&
          Object.keys(result?.resultAnswers[0]).length) ? (
          renderAnswer()
        ) : (
          <div className="mt-1">
            <P_TAG className="py-05 px-2  d-inline">Not Marked</P_TAG>
          </div>
        )}
      </div>
      {!isEnd && <hr />}
    </div>
  );
};

ResultItem.propTypes = {
  result: PropTypes.object.isRequired,
  isEnd: PropTypes.bool.isRequired,
};

export default ResultItem;
